import React, { createContext, useContext, useEffect, useState } from "react";
import client from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await client.get("/auth/me");
                setUser(data);
            } catch { setUser(null); }
            setLoading(false);
        })();
    }, []);

    const login = async (email, password) => {
        const { data } = await client.post("/auth/login", { email, password });
        if (data.token) localStorage.setItem("sj_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const register = async (payload) => {
        const { data } = await client.post("/auth/register", payload);
        if (data.token) localStorage.setItem("sj_token", data.token);
        setUser(data.user);
        return data.user;
    };

    const logout = async () => {
        try { await client.post("/auth/logout"); } catch {}
        localStorage.removeItem("sj_token");
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, login, register, logout, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
